<div class="text-accordion-item">
  <button class="accordion-item-button" [disabled]="disabled" (click)="toggleAccordion()">
    <span class="label">{{ label }}</span>
    <ds-icon [icon]="isOpen && !disabled ? 'up-arrow' : 'down-arrow'" class="icon"></ds-icon>
  </button>

  <div *ngIf="isOpen && !disabled" [@slideDown]>
    <div class="text-content">
      <span [innerHTML]="body" class="body"></span>
    </div>
  </div>
</div>
